import { FormikField, Tooltip } from '@ahmdigital/ui';
import { replace } from 'lodash/fp';
import { useFormikContext } from 'formik';

import { RefinePriceSchemaType } from '../../../../../../features/refine-price/schema';
import canChooseIncomeType from '../../../../../../utils/can-choose-income-type';
import getIncomeTypeOptions from '../../../../../../utils/get-income-type-options';

const IncomeTypeTooltip = (
  <Tooltip>
    Household income type refers to the people in the household, not the income. Even if there’s only one income in your
    household, unless you’ve selected “single cover”, your income type would be “Couple or family — Incl. single parent”{' '}
  </Tooltip>
);

const IncomeTypeField = () => {
  const { setFieldTouched, setFieldValue, values } = useFormikContext<RefinePriceSchemaType>();
  const { scale } = values;

  const helperText =
    !canChooseIncomeType(scale) &&
    `You have chosen ${replace('-', ' ', scale)} cover above, so your income type would be couple or family.`;

  return (
    <FormikField
      {...(helperText && { helperText })}
      inputVariant={['button', 'fullWidth']}
      label="Household income type"
      name="incomeType"
      onBlur={() => setFieldTouched('incomeType', true, false)}
      onChange={(val) => setFieldValue('incomeType', val)}
      options={getIncomeTypeOptions(scale)}
      size="auto"
      tooltip={IncomeTypeTooltip}
      type="radioGroup"
    />
  );
};

export default IncomeTypeField;
